import Row from '@components/Row';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function AccountFooter() {
    const { t } = useTranslation('accountSetting');
    return (
        <Row justify='center' fullWidth>
            <AccountButton>
                {t('buttons.logout')}
            </AccountButton>
            <AccountButton>
                {t('buttons.terminate')}
            </AccountButton>
        </Row>
    );
}

const AccountButton = styled.button`
    padding: 16px;
    color: ${colors.gray7};
    font-size: 12px;
    background-color: transparent;
`;

export default AccountFooter;
